/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateDanceRequest
 */
export interface UpdateDanceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    name: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateDanceRequest
     */
    choreographerUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    cast: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    internalNote: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    routineTitle: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    choreographyStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    musicStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    costumeStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    costumeDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    costumeColor: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    costumeLink: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDanceRequest
     */
    isArchived: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDanceRequest
     */
    musicLink: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDanceRequest
     */
    clearMusicFile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDanceRequest
     */
    clearCostumeImage?: boolean;
}

/**
 * Check if a given object implements the UpdateDanceRequest interface.
 */
export function instanceOfUpdateDanceRequest(value: object): value is UpdateDanceRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('choreographerUserId' in value) || value['choreographerUserId'] === undefined) return false;
    if (!('cast' in value) || value['cast'] === undefined) return false;
    if (!('internalNote' in value) || value['internalNote'] === undefined) return false;
    if (!('routineTitle' in value) || value['routineTitle'] === undefined) return false;
    if (!('choreographyStatus' in value) || value['choreographyStatus'] === undefined) return false;
    if (!('musicStatus' in value) || value['musicStatus'] === undefined) return false;
    if (!('costumeStatus' in value) || value['costumeStatus'] === undefined) return false;
    if (!('costumeDescription' in value) || value['costumeDescription'] === undefined) return false;
    if (!('costumeColor' in value) || value['costumeColor'] === undefined) return false;
    if (!('costumeLink' in value) || value['costumeLink'] === undefined) return false;
    if (!('isArchived' in value) || value['isArchived'] === undefined) return false;
    if (!('musicLink' in value) || value['musicLink'] === undefined) return false;
    return true;
}

export function UpdateDanceRequestFromJSON(json: any): UpdateDanceRequest {
    return UpdateDanceRequestFromJSONTyped(json, false);
}

export function UpdateDanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'choreographerUserId': ApiUserTasksGetPageParameterFromJSON(json['choreographerUserId']),
        'cast': json['cast'],
        'internalNote': json['internalNote'],
        'routineTitle': json['routineTitle'],
        'choreographyStatus': json['choreographyStatus'],
        'musicStatus': json['musicStatus'],
        'costumeStatus': json['costumeStatus'],
        'costumeDescription': json['costumeDescription'],
        'costumeColor': json['costumeColor'],
        'costumeLink': json['costumeLink'],
        'isArchived': json['isArchived'],
        'musicLink': json['musicLink'],
        'clearMusicFile': json['clearMusicFile'] == null ? undefined : json['clearMusicFile'],
        'clearCostumeImage': json['clearCostumeImage'] == null ? undefined : json['clearCostumeImage'],
    };
}

export function UpdateDanceRequestToJSON(json: any): UpdateDanceRequest {
    return UpdateDanceRequestToJSONTyped(json, false);
}

export function UpdateDanceRequestToJSONTyped(value?: UpdateDanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'choreographerUserId': ApiUserTasksGetPageParameterToJSON(value['choreographerUserId']),
        'cast': value['cast'],
        'internalNote': value['internalNote'],
        'routineTitle': value['routineTitle'],
        'choreographyStatus': value['choreographyStatus'],
        'musicStatus': value['musicStatus'],
        'costumeStatus': value['costumeStatus'],
        'costumeDescription': value['costumeDescription'],
        'costumeColor': value['costumeColor'],
        'costumeLink': value['costumeLink'],
        'isArchived': value['isArchived'],
        'musicLink': value['musicLink'],
        'clearMusicFile': value['clearMusicFile'],
        'clearCostumeImage': value['clearCostumeImage'],
    };
}

